(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-best-sellers')) {
    class FeaturedCollectionBestSellers extends HTMLElement {
      constructor() {
        super();
        this.loaded = false;
        this.loading = false;
        this.retryAttempts = 0;
        this.retryTimeout = null;
        this.maxRetryAttempts = 3;
        this.retryLimitReached = false;
        this.lists = Array.from(this.querySelectorAll('[data-featured-collection-best-sellers="true"]'));
        this.toggleButtons = this.querySelectorAll('.featured-collection__toggle');
        this.toggleButtons.forEach((button) => button.addEventListener('click', this.onToggleClick.bind(this)));

        if (!this.lists.length) return;

        this.loadProducts = async () => {
          if (this.loaded || this.loading || this.retryLimitReached) return;
          this.clearLoadRetry();

          const loaded = await this.loadBestSellers();

          if (loaded) {
            this.retryAttempts = 0;
            this.retryLimitReached = false;
            this.carouselObserver?.disconnect();
          } else {
            this.scheduleLoadRetry(this.loadProducts);
          }
        };

        if ('IntersectionObserver' in window) {
          const handleIntersection = (entries) => {
            if (!entries[0].isIntersecting) return;
            this.loadProducts();
          };

          this.carouselObserver = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
          this.carouselObserver.observe(this);
        } else {
          this.loadProducts();
        }

        setTimeout(this.loadProducts, 2000);
      }

      async loadBestSellers() {
        const token = this.dataset.storefrontAccessToken;
        const apiVersion = this.dataset.apiVersion || '2026-04';
        const limit = Math.max(1, Number(this.dataset.productsToShow) || 4);

        if (!token) {
          this.lists.forEach((list) => this.renderEmptyState(list));
          console.error('Featured Collection requires a Storefront access token for best-seller sorting.');
          return false;
        }

        this.loading = true;

        try {
          const results = await Promise.all(this.lists.map((list) => this.loadList(list, token, apiVersion, limit)));
          const loaded = results.every(Boolean);
          this.loaded = loaded;

          if (typeof lazyImages === 'function') lazyImages();
          return loaded;
        } catch (error) {
          this.loaded = false;
          console.error(error);
          return false;
        } finally {
          this.loading = false;
        }
      }

      async loadList(list, token, apiVersion, limit) {
        if (list.dataset.loaded === 'true') return true;

        const collectionHandle = list.dataset.collectionHandle;
        if (!collectionHandle) {
          this.renderEmptyState(list);
          return false;
        }

        try {
          const handles = await this.fetchBestSellerHandles(collectionHandle, limit, token, apiVersion);
          const cardHtml = await Promise.all(handles.map((handle) => this.fetchProductCard(handle, list.dataset.blockId)));
          const cards = cardHtml.filter(Boolean).slice(0, limit);

          if (!cards.length) {
            this.renderEmptyState(list);
            return false;
          }

          const itemClasses = ['grid__item'];
          if (list.classList.contains('slider')) {
            itemClasses.push('slider__slide');
          }

          list.innerHTML = cards.map((html, index) => {
            return `<li role="listitem" class="${itemClasses.join(' ')}" id="Slide-${list.dataset.blockId}-${index + 1}">${html}</li>`;
          }).join('');
          list.dataset.loaded = 'true';
          list.removeAttribute('aria-busy');
          this.resetSlider(list);
          return true;
        } catch (error) {
          this.renderEmptyState(list);
          console.error(error);
          return false;
        }
      }

      clearLoadRetry() {
        window.clearTimeout(this.retryTimeout);
        this.retryTimeout = null;
      }

      scheduleLoadRetry(callback) {
        if (this.loaded || this.retryTimeout || !this.isConnected || this.retryLimitReached) return;
        if (this.retryAttempts >= this.maxRetryAttempts) {
          this.retryLimitReached = true;
          this.carouselObserver?.disconnect();
          return;
        }

        this.retryAttempts += 1;
        this.retryTimeout = window.setTimeout(() => {
          this.retryTimeout = null;
          callback();
        }, 2000 * this.retryAttempts);
      }

      async fetchBestSellerHandles(collectionHandle, limit, token, apiVersion) {
        const handles = [];
        let cursor = null;
        let hasNextPage = true;
        let pagesFetched = 0;
        const pageSize = Math.min(50, Math.max(limit * 2, limit));

        while (handles.length < limit && hasNextPage && pagesFetched < 5) {
          const products = await this.fetchBestSellerProductsPage(collectionHandle, pageSize, cursor, token, apiVersion);
          pagesFetched += 1;
          hasNextPage = Boolean(products?.pageInfo?.hasNextPage);
          cursor = products?.pageInfo?.endCursor || null;

          (products?.nodes || [])
            .filter((product) => product.handle)
            .filter((product) => product.metafield?.value !== 'true')
            .filter((product) => !product.tags?.includes('HIDDEN'))
            .filter((product) => product.vendor !== 'EVG')
            .forEach((product) => {
              if (handles.length < limit) handles.push(product.handle);
            });
        }

        return handles;
      }

      async fetchBestSellerProductsPage(collectionHandle, limit, cursor, token, apiVersion) {
        const response = await fetch(`/api/${apiVersion}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({
            query: `
              query FeaturedCollectionBestSellers($handle: String!, $limit: Int!, $after: String) {
                collection(handle: $handle) {
                  products(first: $limit, after: $after, sortKey: BEST_SELLING) {
                    pageInfo {
                      hasNextPage
                      endCursor
                    }
                    nodes {
                      handle
                      vendor
                      tags
                      metafield(namespace: "inventory", key: "ShappifyHidden") {
                        value
                      }
                    }
                  }
                }
              }
            `,
            variables: {
              handle: collectionHandle,
              limit,
              after: cursor
            }
          })
        });

        if (!response.ok) throw new Error(`Featured Collection GraphQL request failed with ${response.status}`);

        const payload = await response.json();
        if (payload.errors) throw new Error(payload.errors.map((error) => error.message).join(', '));

        return payload.data?.collection?.products;
      }

      async fetchProductCard(handle, blockId) {
        const view = this.dataset.showLifeImage === 'true' ? 'card-product-life-image' : 'card-product';
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=${view}`);
        if (!response.ok) return '';

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.card-wrapper');

        if (card) this.applyCardSettings(card, blockId);

        return card ? card.outerHTML : '';
      }

      applyCardSettings(card, blockId) {
        this.scopeCardIds(card, blockId);
        this.updateImageRatio(card);
        const showSecondaryImage = this.dataset.showSecondaryImage === 'true';
        card.setAttribute('data-show-secondary-image', showSecondaryImage);
        card.querySelector('.card')?.setAttribute('data-show-secondary-image', showSecondaryImage);

        if (this.dataset.showSecondaryImage !== 'true') {
          card.querySelectorAll('.card__hover-image').forEach((element) => element.remove());
        }

        if (this.dataset.showQuickAdd !== 'true') {
          card.querySelectorAll('quick-add, .quick-add__colors').forEach((element) => element.remove());
        }

        if (this.dataset.showRating !== 'true') {
          card.querySelectorAll('.card__rating, .klaviyo-star-rating-widget').forEach((element) => element.remove());
        }

        if (this.dataset.showVendor !== 'true') {
          card.querySelectorAll('.caption-with-letter-spacing.light').forEach((element) => element.remove());
        }
      }

      scopeCardIds(card, blockId) {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        card.querySelectorAll('[id]').forEach((element) => {
          element.id = element.id.replace(/product-card-view/g, `${sectionId}-${blockId}`);
        });
      }

      updateImageRatio(card) {
        const ratioPercent = {
          portrait: '125%',
          square: '100%'
        }[this.dataset.imageRatio];

        if (!ratioPercent) return;

        card.querySelectorAll('.card, .card__inner').forEach((element) => {
          element.style.setProperty('--ratio-percent', ratioPercent);
        });
      }

      renderEmptyState(list) {
        list.innerHTML = '';
        list.removeAttribute('aria-busy');
        this.resetSlider(list);
      }

      onToggleClick(event) {
        const sliderId = event.currentTarget.getAttribute('aria-controls');
        const list = document.getElementById(sliderId);

        window.requestAnimationFrame(() => {
          this.updateSliderButtons(sliderId);

          if (list?.dataset.featuredCollectionBestSellers === 'true' && list.dataset.loaded !== 'true' && !this.loading) {
            const token = this.dataset.storefrontAccessToken;
            const apiVersion = this.dataset.apiVersion || '2026-04';
            const limit = Math.max(1, Number(this.dataset.productsToShow) || 4);

            this.loadList(list, token, apiVersion, limit).then((loaded) => {
              if (loaded && typeof lazyImages === 'function') lazyImages();
            });
          } else if (list) {
            this.resetSlider(list);
          }
        });
      }

      updateSliderButtons(sliderId) {
        this.querySelectorAll('.slider-buttons[data-slider]').forEach((buttons) => {
          buttons.style.display = buttons.dataset.slider === sliderId ? '' : 'none';
        });
      }

      resetSlider(list) {
        if (!list || !list.classList.contains('slider')) return;

        const slider = this.querySelector('slider-component');
        if (!slider || typeof slider.resetPages !== 'function') return;
        if (list.offsetParent === null && window.getComputedStyle(list).display === 'none') return;

        const sliderId = list.getAttribute('id');
        slider.currentPageElement = this.querySelector(`#slider-buttons-${list.dataset.blockId} .slider-counter--current`);
        slider.pageTotalElement = this.querySelector(`#slider-buttons-${list.dataset.blockId} .slider-counter--total`);
        if (typeof slider.setActiveSlider === 'function') {
          slider.setActiveSlider(list);
        } else {
          slider.slider = list;
          slider.sliderItems = list.querySelectorAll('.slider__slide');
          slider.prevButton = slider.querySelector(`button[name="previous"][aria-controls="${sliderId}"]`);
          slider.nextButton = slider.querySelector(`button[name="next"][aria-controls="${sliderId}"]`);
        }

        if (slider.prevButton && slider.nextButton) slider.resetPages();
      }
    }

    customElements.define('featured-collection-best-sellers', FeaturedCollectionBestSellers);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-carousel')) {
    class ProductCarousel extends HTMLElement {
      constructor() {
        super();
        this.loaded = false;
        this.loading = false;
        this.retryAttempts = 0;
        this.retryTimeout = null;
        this.maxRetryAttempts = 3;
        this.retryLimitReached = false;

        if (!this.dataset.collectionHandle) return;

        const loadProducts = async () => {
          if (this.loaded || this.loading || this.retryLimitReached) return;
          this.clearLoadRetry();

          const loaded = await this.loadBestSellers();

          if (loaded) {
            this.retryAttempts = 0;
            this.retryLimitReached = false;
            this.carouselObserver?.disconnect();
          } else {
            this.scheduleLoadRetry(loadProducts);
          }
        };

        if ('IntersectionObserver' in window) {
          const handleIntersection = (entries) => {
            if (!entries[0].isIntersecting) return;
            loadProducts();
          };

          this.carouselObserver = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
          this.carouselObserver.observe(this);
        } else {
          loadProducts();
        }

        setTimeout(loadProducts, 2000);
      }

      async loadBestSellers() {
        const list = this.querySelector('[data-product-carousel-list]');
        const token = this.dataset.storefrontAccessToken;
        const collectionHandle = this.dataset.collectionHandle;
        const apiVersion = this.dataset.apiVersion || '2026-04';
        const limit = Math.max(1, Number(this.dataset.productsToShow) || 8);

        if (!list || !collectionHandle || !token) {
          this.renderEmptyState();
          if (!token) console.error('Product Carousel requires a Storefront access token for best-seller sorting.');
          return false;
        }

        this.loading = true;

        try {
          const handles = await this.fetchBestSellerHandles(collectionHandle, limit, token, apiVersion);
          const cardHtml = await Promise.all(handles.map((handle) => this.fetchProductCard(handle)));
          const cards = cardHtml.filter(Boolean).slice(0, limit);

          if (!cards.length) {
            this.renderEmptyState();
            this.loaded = false;
            return false;
          }

          const itemClasses = ['grid__item'];
          if (
            this.dataset.desktopCarousel === 'true' ||
            this.dataset.mobileLayout === 'carousel' ||
            this.dataset.layout === 'mobile_carousel' ||
            this.dataset.layout === 'carousel'
          ) {
            itemClasses.push('slider__slide');
          }

          list.innerHTML = cards.map((html, index) => {
            return `<li class="${itemClasses.join(' ')}" id="Slide-${this.dataset.sectionId}-${index + 1}">${html}</li>`;
          }).join('');
          this.loaded = true;
          this.classList.add('product-recommendations--loaded');
          this.resetSlider();

          if (typeof lazyImages === 'function') lazyImages();
          return true;
        } catch (error) {
          this.loaded = false;
          this.renderEmptyState();
          console.error(error);
          return false;
        } finally {
          this.loading = false;
        }
      }

      clearLoadRetry() {
        window.clearTimeout(this.retryTimeout);
        this.retryTimeout = null;
      }

      scheduleLoadRetry(callback) {
        if (this.loaded || this.retryTimeout || !this.isConnected || this.retryLimitReached) return;
        if (this.retryAttempts >= this.maxRetryAttempts) {
          this.retryLimitReached = true;
          this.carouselObserver?.disconnect();
          return;
        }

        this.retryAttempts += 1;
        this.retryTimeout = window.setTimeout(() => {
          this.retryTimeout = null;
          callback();
        }, 2000 * this.retryAttempts);
      }

      async fetchBestSellerHandles(collectionHandle, limit, token, apiVersion) {
        const handles = [];
        let cursor = null;
        let hasNextPage = true;
        let pagesFetched = 0;
        const pageSize = Math.min(50, Math.max(limit * 2, limit));

        while (handles.length < limit && hasNextPage && pagesFetched < 5) {
          const products = await this.fetchBestSellerProductsPage(collectionHandle, pageSize, cursor, token, apiVersion);
          pagesFetched += 1;
          hasNextPage = Boolean(products?.pageInfo?.hasNextPage);
          cursor = products?.pageInfo?.endCursor || null;

          (products?.nodes || [])
            .filter((product) => product.handle)
            .filter((product) => product.metafield?.value !== 'true')
            .filter((product) => !product.tags?.includes('HIDDEN'))
            .filter((product) => product.vendor !== 'EVG')
            .forEach((product) => {
              if (handles.length < limit) handles.push(product.handle);
            });
        }

        return handles;
      }

      async fetchBestSellerProductsPage(collectionHandle, limit, cursor, token, apiVersion) {
        const response = await fetch(`/api/${apiVersion}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({
            query: `
              query ProductCarouselBestSellers($handle: String!, $limit: Int!, $after: String) {
                collection(handle: $handle) {
                  products(first: $limit, after: $after, sortKey: BEST_SELLING) {
                    pageInfo {
                      hasNextPage
                      endCursor
                    }
                    nodes {
                      handle
                      vendor
                      tags
                      metafield(namespace: "inventory", key: "ShappifyHidden") {
                        value
                      }
                    }
                  }
                }
              }
            `,
            variables: {
              handle: collectionHandle,
              limit,
              after: cursor
            }
          })
        });

        if (!response.ok) throw new Error(`Product Carousel GraphQL request failed with ${response.status}`);

        const payload = await response.json();
        if (payload.errors) throw new Error(payload.errors.map((error) => error.message).join(', '));

        return payload.data?.collection?.products;
      }

      async fetchProductCard(handle) {
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=card-product`);
        if (!response.ok) return '';

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.card-wrapper');

        if (card) this.applyCardSettings(card);

        return card ? card.outerHTML : '';
      }

      applyCardSettings(card) {
        this.scopeCardIds(card);
        this.updateImageRatio(card);
        const showSecondaryImage = this.dataset.showSecondaryImage === 'true';
        card.setAttribute('data-show-secondary-image', showSecondaryImage);
        card.querySelector('.card')?.setAttribute('data-show-secondary-image', showSecondaryImage);

        if (this.dataset.showSecondaryImage !== 'true') {
          card.querySelectorAll('.card__hover-image').forEach((element) => element.remove());
        }

        if (this.dataset.showQuickAdd !== 'true') {
          card.querySelectorAll('quick-add, .quick-add__colors').forEach((element) => element.remove());
        }

        if (this.dataset.showRating !== 'true') {
          card.querySelectorAll('.card__rating, .klaviyo-star-rating-widget').forEach((element) => element.remove());
        }

        if (this.dataset.showVendor !== 'true') {
          card.querySelectorAll('.caption-with-letter-spacing.light').forEach((element) => element.remove());
        }
      }

      scopeCardIds(card) {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        card.querySelectorAll('[id]').forEach((element) => {
          element.id = element.id.replace(/product-card-view/g, sectionId);
        });
      }

      updateImageRatio(card) {
        const ratioPercent = {
          portrait: '125%',
          square: '100%'
        }[this.dataset.imageRatio];

        if (!ratioPercent) return;

        card.querySelectorAll('.card, .card__inner').forEach((element) => {
          element.style.setProperty('--ratio-percent', ratioPercent);
        });
      }

      renderEmptyState() {
        const list = this.querySelector('[data-product-carousel-list]');
        if (list) list.innerHTML = '';
        this.classList.remove('product-recommendations--loaded');
        this.resetSlider();
      }

      resetSlider() {
        const slider = this.closest('slider-component');
        const sliderList = slider?.querySelector('.slider');
        if (!slider || !sliderList || typeof slider.resetPages !== 'function') return;

        const sliderId = sliderList.getAttribute('id');
        const hasSliderControls = slider.querySelector(`button[name="previous"][aria-controls="${sliderId}"]`)
          && slider.querySelector(`button[name="next"][aria-controls="${sliderId}"]`);

        if (hasSliderControls) slider.resetPages();
      }
    }

    customElements.define('product-carousel', ProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-ai"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            lazyImages();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
      this.loading = false;
      this.retryAttempts = 0;
      this.retryTimeout = null;
      this.maxRetryAttempts = 3;
      this.retryLimitReached = false;

      const loadRecommendations = async () => {
        if (this.loaded || this.loading || this.retryLimitReached) return;
        this.clearLoadRetry();

        const loaded = await this.fetchRecommendations();

        if (loaded) {
          this.retryAttempts = 0;
          this.retryLimitReached = false;
          this.recommendationsObserver?.disconnect();
        } else {
          this.scheduleLoadRetry(loadRecommendations);
        }
      };

      const handleIntersection = (entries) => {
        if (!entries[0].isIntersecting) return;
        loadRecommendations();
      }

      this.recommendationsObserver = new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'});
      this.recommendationsObserver.observe(this);
      setTimeout(loadRecommendations, 2000);
    }

    async fetchRecommendations() {
      this.loading = true;

      try {
        const response = await fetch(this.dataset.url);
        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        this.innerHTML = recommendations ? recommendations.innerHTML : '';

        const hasRecommendations = Boolean(recommendations?.querySelector('.grid__item:not(.product-recommendations__skeleton-card)'));
        this.classList.remove('product-recommendations--loading');

        if (hasRecommendations) {
          this.loaded = true;
          this.classList.add('product-recommendations--loaded');
        } else {
          this.loaded = false;
          this.classList.remove('product-recommendations--loaded');
        }

        this.resetSlider();
        if (typeof lazyImages === 'function') lazyImages();
        return hasRecommendations;
      } catch (e) {
        this.loaded = false;
        console.error(e);
        return false;
      } finally {
        this.loading = false;
      }
    }

    clearLoadRetry() {
      window.clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }

    scheduleLoadRetry(callback) {
      if (this.loaded || this.retryTimeout || !this.isConnected || this.retryLimitReached) return;
      if (this.retryAttempts >= this.maxRetryAttempts) {
        this.retryLimitReached = true;
        this.classList.remove('product-recommendations--loading');
        this.innerHTML = '';
        this.recommendationsObserver?.disconnect();
        return;
      }

      this.retryAttempts += 1;
      this.retryTimeout = window.setTimeout(() => {
        this.retryTimeout = null;
        callback();
      }, 2000 * this.retryAttempts);
    }

    resetSlider() {
      const slider = this.closest('slider-component');
      const sliderList = slider?.querySelector('.slider');
      if (!slider || !sliderList || typeof slider.initPages !== 'function') return;

      const sliderId = sliderList.getAttribute('id');
      const prevButton = slider.querySelector(`button[name="previous"][aria-controls="${sliderId}"]`);
      const nextButton = slider.querySelector(`button[name="next"][aria-controls="${sliderId}"]`);
      const sliderComponentAlreadyBound = slider.slider === sliderList && slider.prevButton === prevButton && slider.nextButton === nextButton;

      slider.slider = sliderList;
      slider.sliderItems = slider.slider.querySelectorAll('.slider__slide');
      slider.currentPageElement = slider.querySelector('.slider-counter--current');
      slider.pageTotalElement = slider.querySelector('.slider-counter--total');
      slider.prevButton = prevButton;
      slider.nextButton = nextButton;

      if (!slider.prevButton || !slider.nextButton) return;

      if (
        !sliderComponentAlreadyBound &&
        (slider.productRecommendationsBoundSlider !== slider.slider ||
          slider.productRecommendationsBoundPrevButton !== slider.prevButton ||
          slider.productRecommendationsBoundNextButton !== slider.nextButton)
      ) {
        slider.productRecommendationsResizeObserver?.disconnect();

        slider.productRecommendationsOnScroll = slider.update.bind(slider);
        slider.productRecommendationsOnPreviousClick = slider.onButtonClick.bind(slider);
        slider.productRecommendationsOnNextClick = slider.onButtonClick.bind(slider);
        slider.slider.addEventListener('scroll', slider.productRecommendationsOnScroll);
        slider.prevButton.addEventListener('click', slider.productRecommendationsOnPreviousClick);
        slider.nextButton.addEventListener('click', slider.productRecommendationsOnNextClick);
        slider.productRecommendationsBoundSlider = slider.slider;
        slider.productRecommendationsBoundPrevButton = slider.prevButton;
        slider.productRecommendationsBoundNextButton = slider.nextButton;

        if ('ResizeObserver' in window) {
          slider.productRecommendationsResizeObserver = new ResizeObserver(() => slider.initPages());
          slider.productRecommendationsResizeObserver.observe(slider.slider);
        }
      }

      slider.initPages();
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
